/**
 * URL Slugs dictionary for all supported languages.
 * Maps the HTML section IDs to translated URL paths.
 */
export const routeSlugs = {
  en: { home: '', features: 'features', 'how-it-works': 'how-it-works', pricing: 'pricing' },
  nl: { home: '', features: 'functies', 'how-it-works': 'hoe-het-werkt', pricing: 'prijzen' },
  de: { home: '', features: 'funktionen', 'how-it-works': 'wie-es-funktioniert', pricing: 'preise' },
  fr: { home: '', features: 'fonctionnalites', 'how-it-works': 'comment-ca-marche', pricing: 'tarifs' },
  es: { home: '', features: 'caracteristicas', 'how-it-works': 'como-funciona', pricing: 'precios' },
  it: { home: '', features: 'caratteristiche', 'how-it-works': 'come-funziona', pricing: 'prezzi' },
  pl: { home: '', features: 'funkcje', 'how-it-works': 'jak-to-dziala', pricing: 'cennik' },
  sv: { home: '', features: 'funktioner', 'how-it-works': 'hur-det-fungerar', pricing: 'priser' },
  da: { home: '', features: 'funktioner', 'how-it-works': 'hvordan-det-virker', pricing: 'priser' },
  pt: { home: '', features: 'recursos', 'how-it-works': 'como-funciona', pricing: 'precos' },
  fi: { home: '', features: 'ominaisuudet', 'how-it-works': 'kuinka-se-toimii', pricing: 'hinnasto' },
  el: { home: '', features: 'xaraktiristika', 'how-it-works': 'pos-leitourgei', pricing: 'times' },
  cs: { home: '', features: 'funkce', 'how-it-works': 'jak-to-funguje', pricing: 'ceny' }
};

export const getSlug = (lang, section) => {
  const langSlugs = routeSlugs[lang] || routeSlugs['en'];
  return langSlugs[section] ?? routeSlugs['en'][section];
};

export const getSectionFromSlug = (lang, slug) => {
  if (!slug) return 'home';
  const langSlugs = routeSlugs[lang] || routeSlugs['en'];
  for (const [section, translatedSlug] of Object.entries(langSlugs)) {
    if (translatedSlug === slug) return section;
  }
  return null;
};